module.exports = __webpack_public_path__ + "static/media/white-googlepixel.0d69a980.png";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/white-googlepixel.png
// module id = 444
// module chunks = 0